<!--
  Created by Caroline on 2019/11/25 0025.
-->
<template>
  <div class="container">

    <div class="album">
      <swiper :options="swiperOption" ref="albumSwiper">
        <swiper-slide v-for="(item, index) in imgsShowList" :key="index+1">
          <div class="slide--wrapper">
            <img :src="item" class="img--blur" @load="imgOnload(index, item)"/>
<!--            <img :src="item" class="img&#45;&#45;blur"/>-->
            <div class="img--div" :style="{'background-image': 'url('+item+')'}"></div>
          </div>
        </swiper-slide>
      </swiper>
    </div>

    <div class="barrage--wrapper">
      <barrage
        ref="barrage"
        class="barrage"
        :barrage-list="barrageList"
        :speed="barrage.speed"
        :loop="barrage.loop"
        :channels="barrage.channels"
      ></barrage>
    </div>

  </div>
</template>

<script>
  import {mapActions, mapState, mapGetters} from 'vuex'

  let self

  export default {
    name: "album",
    components: {},
    data() {
      return {
        imgs: [],   // 所有图片
        imgsShowList: [],   // 显示的图片

        modeChanged: true,

        start: false,
        imgLoadedCount: 0,
        startLoadCount: 3,
        pieceC: 5,  // 每次加载加载数 pieceLoadCount
        swiperIdx: 0,
        swiperNextTimeout: null,
        delay: 3000,
        // delay: 1500,
        swiperOption: {
          autoplay: false,
          speed: 2000,
          effect: 'fade',
          loop: false,    // 设置不循环时，仍然会循环，并且获取到的activeIndex才是正常的
          simulateTouch: false,  // 鼠标点击拖动
          updateOnImagesReady: true,
          on: {
            slideChangeTransitionEnd: this.slideChangeTransitionEnd,
            beforeDestroy: this.beforeDestroy,
          },
        },

        barrageList: [],
        barrage: {
          speed: 3,
          loop: true,
          channels: 2,
        },

      }
    },
    computed: {
      ...mapState(['win', 'activityId', 'modeData', 'imageList',]),
      ...mapGetters(['scale', 'blessingList', 'newBlessing']),
      showBlessing() {
        return this.modeData.albumConfig.showBlessing
      },
      swiper() {
        return this.$refs.albumSwiper ? this.$refs.albumSwiper.swiper : null
      },
    },
    watch: {
      win(val) {
        // console.log("album watch win",);
        this.$nextTick(() => {
          this.setBarrageList(this.showBlessing, this.blessingList)
        })
      },
      modeData() {
        // console.log("ab modeData change",);
        this.modeChanged = true
      },
      imageList(val) {
        // console.log("ab watch imageList", val.length);
        if(this.modeChanged) {
          // clearPlayerData
          this.start = false
          this.modeChanged = false
          this.swiperIdx = 0
          this.imgLoadedCount = 0
          this.imgs = []
          this.imgsShowList = []

          this.$nextTick(() => {
            this.imgs = [...val]
            this.imgsShowList = [...this.imgs.splice(0, this.startLoadCount)]
            this.swiper.update()
          })

        } else {
          this.imgs = [...val]
        }
      },
      blessingList(val) {
        console.log("ab watch blessingList", );
        this.setBarrageList(this.showBlessing, val)
      },
      newBlessing(val) {
        // console.log("album watch newBlessing", val);
        this.$refs.barrage.add(val)
      },
    },
    created() {
      self = this
    },
    methods: {
      ...mapActions(['getImageList', 'updateBlessingListByNew', 'showToast']),

      /* region imagePlayer */
      addShowImgsList() {
        // console.log("add", );
        let img = this.imgs.shift()
        // console.log("img", img);
        // 获取新 imageList
        if(this.imgs.length === 0){
          this.getImageList()
        }
        this.imgsShowList.push(img)
      },
      imgOnload(idx, imgUrl) {
        // console.log("imgOnload", idx);
        // 前3张加载完毕再开始
        this.imgLoadedCount++
        console.log("imgOnload", this.imgLoadedCount, this.startLoadCount, this.imgsShowList.length);
        let startLoadCount = this.startLoadCount > this.imgsShowList.length ? this.imgsShowList.length : this.startLoadCount

        if(this.imgLoadedCount === startLoadCount){
          this.start = true
          console.log("imgOnload start", this.start);
          let to = setTimeout(() => {
            this.swiperNext()
            this.setBarrageList(this.showBlessing, this.blessingList)
            clearTimeout(to)
          }, this.delay)
        }
      },
      /* endregion */

      /* region swiper */
      swiperNext () {
        console.log('swiperNext')
        this.swiperIdx++
        this.$nextTick(() => {
          this.swiper && !this.swiper.destroyed && this.swiper.slideNext()
        })
      },
      slideChangeTransitionEnd () {
        console.log("changed start", this.start);
        if(this.start){
          // console.log("swiperIdx", this.swiperIdx);
          this.addShowImgsList()
          // console.log(`changed: swiperIdx ${this.swiperIdx}, imgsShowList ${this.imgsShowList.length}`, )

          // 移除首个 slide
          if(this.imgsShowList.length > this.pieceC){
            this.swiper.removeSlide(0)
          }

          // 下一张
          this.swiperNextTimeout = setTimeout(() => {
            this.swiperNext()
            clearTimeout(this.swiperNextTimeout)
          }, this.delay)
        }
      },
      beforeDestroy () {
        console.log("beforeDestroy",);
        this.start = false
      },
      swiperAutoStart () {
        this.swiper && this.swiper.autoplay.start()
      },
      swiperAutoStop () {
        this.swiper && this.swiper.autoplay.stop()
      },
      /* endregion */

      /* region barrage */
      hideBarrageList () {
        this.barrageList = []
      },
      setBarrageList (showBlessing, list) {
        this.barrageList = showBlessing ? list : []
      },
      /* endregion */

    }
  }
</script>

<style scoped lang="less">
  @import "../less/common.less";
  @import "../less/album.less";

  .btn {
    position: absolute;
    bottom: 50px;
    width: 300px;
    font-size: 16px;
    line-height: 50px;
    background-color: #cccccc;
    cursor: pointer;
    z-index: 10;
  }
</style>



// WEBPACK FOOTER //
// src/components/album.vue